import type { SVGProps } from 'react';

const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M13.2057 11.2941H18.1469C18.5366 11.2941 18.8528 11.6103 18.8528 12C18.8528 12.3896 18.5366 12.7059 18.1469 12.7059H13.2057V17.647C13.2057 18.0367 12.8895 18.3529 12.4999 18.3529C12.1102 18.3529 11.794 18.0367 11.794 17.647V12.7059H6.85279C6.46315 12.7059 6.14691 12.3896 6.14691 12C6.14691 11.6103 6.46315 11.2941 6.85279 11.2941H11.794V6.35292C11.794 5.96327 12.1102 5.64704 12.4999 5.64704C12.8895 5.64704 13.2057 5.96327 13.2057 6.35292V11.2941Z"
            fill="currentColor"
        />
    </svg>
);

export default PlusIcon;
